import { render, staticRenderFns } from "./the-my-account.vue?vue&type=template&id=af6688d0&scoped=true"
import script from "./the-my-account.vue?vue&type=script&lang=js"
export * from "./the-my-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6688d0",
  null
  
)

export default component.exports